// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__1uaJ2","isError":"Select_isError__KiuHZ","selectWrapper":"Select_selectWrapper__tsAIz","container":"Select_container__I_RUT","scale":"Select_scale__imQLQ"};